import { convertTemperature1, convertTemperatureUnit, isUndefinedOrNull } from '#helper';

export const normalizeNumberField = value => {
  const matched = `${value}`.match(/(-)?(\d){0,}(\.|,)?(\d)?/);
  return matched ? matched[0].replace(/,/, '.') : '';
};

/**
 * Creates title for alert item.
 * @param {item} item - alert item.
 * @param {("metric" | "us")} unitSystem - current unit system
 * @param {("metric" | "us")} destinationUintSystem - unit system to convert into
 * @returns {string} - item title.
 */

export const createTitle = (item, unitSystem, destinationUintSystem) => {
  const { label, tMin, tMax, hMin, hMax, bMin } = item;

  const ct = value => convertTemperature1(value, unitSystem, destinationUintSystem, 1);
  let title = '';
  if (label) {
    title += `/ ${label}`;
  }
  if (!isUndefinedOrNull(tMin) && !isUndefinedOrNull(tMax) && tMin !== '' && tMax !== '') {
    title += ` / ${ct(tMin)} ${tMax.toString().charAt(0) === '-' ? 'to' : '-'} ${ct(tMax)}${convertTemperatureUnit(destinationUintSystem)}`;
  } else if (!isUndefinedOrNull(tMin) && tMin !== '') {
    title += ` / T min: ${ct(tMin)}${convertTemperatureUnit(destinationUintSystem)}`;
  } else if (!isUndefinedOrNull(tMax) && tMax !== '') {
    title += ` / T max: ${ct(tMax)}${convertTemperatureUnit(destinationUintSystem)}`;
  }

  if (!isUndefinedOrNull(hMin) && !isUndefinedOrNull(hMax) && hMin !== '' && hMax !== '') {
    title += ` / ${hMin} - ${hMax}%`;
  } else if (!isUndefinedOrNull(hMin) && hMin !== '') {
    title += ` / H min: ${hMin}%`;
  } else if (!isUndefinedOrNull(hMax) && hMax !== '') {
    title += ` / H max: ${hMax}%`;
  }

  if (!isUndefinedOrNull(bMin) && bMin !== '') {
    title += ` / B min: ${bMin}%`;
  }
  return title.slice(2).trim();
};

/**
 * Derives last key from field name.
 * @param {string} name - field name.
 * @returns {string} key.
 */

export const getNameKey = (name = '') => {
  const splittedName = name.split('.');
  return splittedName[splittedName.length - 1];
};
